module.exports = __webpack_public_path__ + "img/background-base.fa85a9be.svg";